import { createContext } from 'react';
const defaultValue = {
    checked: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setChecked: () => { },
    name: undefined,
    error: false,
};
const RadioContext = createContext(defaultValue);
export default RadioContext;
//# sourceMappingURL=RadioContext.js.map